// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2G-45","name":"styles_name__1a-UO","phone":"styles_phone__2-LKt"};